import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, Images, Upload, Tags, Users, BarChart3 } from "lucide-react";
import { Navbar } from "../../components/Navbar";
import { Footer } from "../../components/Footer";

const LINKS = [
  { to: "/admin", end: true, label: "Dashboard", icon: LayoutDashboard, testId: "admin-nav-dashboard" },
  { to: "/admin/ads", label: "Ads & Ordering", icon: Images, testId: "admin-nav-ads" },
  { to: "/admin/upload", label: "Upload", icon: Upload, testId: "admin-nav-upload" },
  { to: "/admin/categories", label: "Categories", icon: Tags, testId: "admin-nav-categories" },
  { to: "/admin/clients", label: "Clients", icon: Users, testId: "admin-nav-clients" },
  { to: "/admin/analytics", label: "Insights", icon: BarChart3, testId: "admin-nav-analytics" },
];

export default function AdminLayout() {
  return (
    <div className="min-h-screen bg-[#F9FAFB] flex flex-col">
      <Navbar />
      <div className="max-w-7xl mx-auto px-6 py-8 flex-1 w-full">
        <div className="flex flex-wrap gap-2 mb-8">
          {LINKS.map(({ to, end, label, icon: Icon, testId }) => (
            <NavLink
              key={to} to={to} end={end} data-testid={testId}
              className={({ isActive }) =>
                `flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200 ${
                  isActive ? "bg-[#000000] text-white" : "bg-white border border-gray-200 text-gray-600 hover:bg-gray-100"
                }`
              }
            >
              <Icon size={15} />
              {label}
            </NavLink>
          ))}
        </div>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}
